var _style, _g, _desc, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccomodation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.6,33.4c-0.9-1.2-2.1-1.8-3.6-1.8c-3.7,0-7.4,0-11.2,0h-0.4c0-0.7,0-1.4,0-2.1c0-1.8-1.3-3.2-3.2-3.3 c-1.8,0-3.6,0-5.4,0c-1.9,0-3.2,1.4-3.2,3.3c0,1.3,0,2.6,0,3.8v0.3h0.5h22.6c0.1,0,0.2,0,0.3,0c1.4,0,2.3,0.9,2.3,2.3 c0,1.2,0,2.5,0,3.7v0.4H21.5V22h-2.1v25.6h2.1v-5.3h27.7v5.3h2.1v-0.4c0-3.8,0-7.6,0-11.4C51.4,34.9,51.1,34.1,50.6,33.4z  M33.3,31.6h-7.4v-1c0-0.4,0-0.7,0-1.1c0-0.6,0.4-1,0.9-1c1.9,0,3.8,0,5.7,0c0.5,0,0.8,0.3,0.8,0.8C33.3,30,33.3,30.8,33.3,31.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.7,
    y: 35.9,
    className: "st0",
    width: 11.7,
    height: 2.1
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "other - services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.000000, 11.016480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.694777, 0.913268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomodation);
export default __webpack_public_path__ + "static/media/accomodation.23b188fb.svg";
export { ForwardRef as ReactComponent };